module.exports = __webpack_public_path__ + "static/assets/b0fe759c1c5e7ff9278186862535a47e.svg";